import React from "react";
import PropTypes from "prop-types";
import { List, ListItem } from "react-md";
import { getUserType } from "../../../utils";

const Members = ({ members }) => {
  return (
    <List ordered>
      {members &&
        members.map((user, i) => (
          <ListItem
            // There is no unique parameter (firstName and lastName of user may be the same)
            //     so we use index for key
            /* eslint-disable react/no-array-index-key */
            key={i}
            /* eslint-enable react/no-array-index-key */
            primaryText={`${user.firstName} ${user.lastName}`}
            rightAvatar={
              getUserType(user) &&
                <div className="queue-item--user-type">{getUserType(user)}</div>
            }
            inkDisabled
          />
        ))}
    </List>
  );
};

Members.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired
    })
  )
};

export default Members;



// WEBPACK FOOTER //
// ./src/staff/components/Queue/Registration/Members.jsx